// extracted by mini-css-extract-plugin
module.exports = {"buttons":"LoginAuth_buttons__1w0mE"};